import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store'
import Home from './views/Home.vue'
// import CreateEvent from './views/CreateEvent.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/confirmParticipation/:id/:token',
      name: 'confirmParticipation',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "confirm" */ './views/confirmParticipation.vue')
    },
    {
      path: '/event-landing/:eventId/:userIdentifier?',
      name: 'eventLanding',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "eventLanding" */ './views/eventLanding.vue')
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/dashboard',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "dash" */ './views/Dashboard.vue'),
      meta: { requriesAuth: true },
      children: [
        {
          path: '/',
          name: 'dashboard-overview',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "dashover" */ './views/Dashboard-Overview.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/usersettings',
          name: 'usersettings',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "usersettings" */ './views/UserSettings.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/createevent',
          name: 'createevent',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "createevent" */ './views/CreateEvent.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/help',
          name: 'help',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "createevent" */ './views/Help.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/events',
          name: 'events',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "events" */ './views/Events.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/event/:id',
          name: 'event',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "createevent" */ './views/CreateEvent.vue'),
          meta: { requriesAuth: true }
        },
        {
          path: '/event',
          // name: 'detail',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "createevent" */ './views/Event.vue'),
          // meta: { requriesAuth: true },
          children: [
            {
              path: ':id/detail',
              name: 'detail',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "createevent" */ './views/EventDetail.vue'),
              meta: { requriesAuth: true }
            },
            {
              path: ':id/participants',
              name: 'participants',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "createevent" */ './views/EventParticipants.vue'),
              meta: { requriesAuth: true }
            },
            {
              path: ':id/participant/:pid/detail',
              name: 'participantDetail',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "createevent" */ './views/EventParticipantDetail.vue'),
              meta: { requriesAuth: true }
            },
            {
              path: ':id/emails',
              name: 'emails',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "createevent" */ './views/EventEmails.vue'),
              meta: { requriesAuth: true }
            },
            {
              path: ':id/reporting',
              name: 'reporting',
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "createevent" */ './views/EventReport.vue'),
              meta: { requriesAuth: true }
            }
          ]
        }
      ]
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requriesAuth)) {
    if (!store.user.state.isLoggedIn) {
      next({
        name: 'login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
